import { Col, Form, FormInstance, Input, Row } from "antd"
import { PlusCircleOutlined } from "@ant-design/icons"

import { SubmitButton } from "@src/shared/componemts/SubmitButton"

type Props = {
  form: FormInstance<any>
  submit: (req: any) => void
}
export const CallBackUrlForm = ({ form, submit }: Props) => {
  return (
    <Form
      form={form}
      id="GENERATED_ID_CALLBACKURLFORM_FORM_VOID_1"
      layout="vertical"
      name="CallBackUrlForm"
      onFinish={submit}
      size="large"
    >
      <Row align="top" gutter={16}>
        <Col span={21}>
          <Form.Item
            id="GENERATED_ID_CALLBACKURLFORM_TSX_FORM.ITEM_VOID_1"
            label="Callback URL"
            name="callback_url"
            rules={[
              { message: "URL is required", required: true, type: "url" },
            ]}
          >
            <Input placeholder="https://mydomain.shop" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            id="GENERATED_ID_CALLBACKURLFORM_TSX_FORM.ITEM_VOID_2"
            label={" "}
          >
            <SubmitButton
              buttonProps={{
                icon: <PlusCircleOutlined />,
                size: "large",
                type: "primary",
              }}
              form={form}
            >
              Confirm
            </SubmitButton>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
